import type { Conflict } from '../types/conflict';
import type { PaginatedResponse, PaginationParams } from '../types/pagination';
import api from './api';

export const conflictService = {
  async getConflicts(params?: PaginationParams): Promise<PaginatedResponse<Conflict>> {
    const response = await api.get('/conflicts', { params });
    return response.data;
  }
};
